import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, List, Settings, LogOut, Bot } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export const MinimizedSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('selectedIB');
    navigate('/login');
  };

  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard', testId: 'nav-dashboard' },
    { icon: List, label: 'IB Management', path: '/ib-management/list', testId: 'nav-ib-management' },
    { icon: Bot, label: 'AI Agent', path: '/ai-agent', testId: 'nav-ai-agent' },
    { icon: Settings, label: 'Settings', path: '/settings', testId: 'nav-settings' },
  ];

  return (
    <div className="w-16 h-screen bg-[#141416] border-r border-[#2A2A2E] flex-col fixed left-0 top-0 bottom-0 z-50 hidden md:flex">
      <div className="p-3 border-b border-[#2A2A2E] flex items-center justify-center">
        <img 
          src="https://customer-assets.emergentagent.com/job_channel-crm-system/artifacts/4egfgzp6_ua%20logo.png" 
          alt="U" 
          className="h-8 w-8 object-contain"
          data-testid="sidebar-logo-mini"
        />
      </div>

      <nav className="flex-1 p-2 space-y-2">
        <TooltipProvider delayDuration={0}>
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path || 
              (item.path === '/ib-management/list' && location.pathname.includes('/ib/'));

            return (
              <Tooltip key={item.path}>
                <TooltipTrigger asChild>
                  <Button
                    variant="ghost"
                    size="icon"
                    className={`w-full h-12 ${
                      isActive 
                        ? 'bg-[#E63946]/20 text-[#E63946] hover:bg-[#E63946]/30 hover:text-[#E63946]' 
                        : 'text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]'
                    }`}
                    onClick={() => navigate(item.path)}
                    data-testid={item.testId}
                  >
                    <Icon size={20} />
                  </Button>
                </TooltipTrigger>
                <TooltipContent side="right" className="bg-[#1C1C1F] border-[#2A2A2E] text-[#F8F9FA]">
                  {item.label}
                </TooltipContent>
              </Tooltip>
            );
          })}
        </TooltipProvider>
      </nav>

      <div className="p-2 border-t border-[#2A2A2E]">
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="w-full h-12 text-[#ADB5BD] hover:bg-[#1C1C1F] hover:text-[#F8F9FA]"
                onClick={handleLogout}
                data-testid="nav-logout"
              >
                <LogOut size={20} />
              </Button>
            </TooltipTrigger>
            <TooltipContent side="right" className="bg-[#1C1C1F] border-[#2A2A2E] text-[#F8F9FA]">
              Logout
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
};
